import * as modal from '../modal'
import * as modals from '../../../constants/modals'
import * as types from './types'

export const receiveAlert =
  (options = {}) =>
  (dispatch) => {
    const { title, message, action, route } = options

    dispatch(modal.actions.receiveModal(modals.ALERT_MODAL_ID))

    dispatch({
      type: types.RECEIVE_ALERT,
      payload: {
        title,
        message,
        action,
        route
      }
    })
  }

export const closeAlert = () => [
  {
    type: types.RESET_ALERT
  },
  modal.actions.resetModal()
]
